define('glu/grid/filter/badges/filterBadgesHeaderLayout',['require','../../../layout','hbs!./filterBadgesHeaderLayout.hbs','./filterBadgesRowHeader','./auxControl'],function(require) {
    'use strict';

    var Layout = require('../../../layout'),
        tmpl = require('hbs!./filterBadgesHeaderLayout.hbs'),
        FilterBadgesRowHeader = require('./filterBadgesRowHeader'),
        AuxControl = require('./auxControl');

    return Layout.extend({
        template: tmpl,

        regions: {
            filterBadges: '.region-filter-badges',
            auxControl: '.region-aux-control'
        },

        onRender: function() {
            this.showFilterBadges();
            this.showAuxControl();
        },

        showFilterBadges: function() {
            this.filterBadges.show(new FilterBadgesRowHeader({
                columns: this.options.columns,
                masterCollection: this.options.masterCollection,
                filters: this.options.filterProc.filters
            }));
        },

        showAuxControl: function() {
            this.auxControl.show(new AuxControl({
                collection: this.options.masterCollection,
                filterProc: this.options.filterProc
            }));
        }
    });
});

